.container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  margin-top: 8px;
  margin-bottom: 8px;
  border-style: solid;
  border-color: var(--tuna-palette-divider);
  background-color: var(--tuna-palette-action-hover);
  border-width: 1px;
  border-radius: var(--tuna-shape-radius-md);
}

/*
 * Composer focus ring accent (Joni §2). Neutral fallback keeps the human
 * Chat tool, which never sets `--agent-accent`, byte-identical.
 */
.container:focus-within {
  box-shadow: 0 0 0 2px var(--agent-accent, var(--tuna-focus-ring, transparent));
  border-radius: var(--tuna-shape-radius-sm);
}

.avatar {
  margin-right: 8px;
}

.editor {
  flex: 1;
  flex-direction: column;
  padding: 0 8px;
  display: flex;
  justify-content: center;
}
